import { getSystemReleaseContext } from "./system";

function context(key) {
  return getSystemReleaseContext() + key;
}

function getTokenKey() {
  return context("/USER_TOKEN");
}

export function getToken() {
  const key = getTokenKey();
  return localStorage.getItem(key);
};

export function setToken(token) {
  const key = getTokenKey();
  localStorage.setItem(key, token);
};

export function removeToken() {
  const key = getTokenKey();
  localStorage.removeItem(key);
};

function getPositionKey() {
  return context("/USER_POSITION");
}

export function getPosition() {
  const key = getPositionKey();
  return localStorage.getItem(key);
};

export function setPosition(token) {
  const key = getPositionKey();
  localStorage.setItem(key, token);
};

export function removePosition() {
  const key = getPositionKey();
  localStorage.removeItem(key);
};

export function reset() {
  removeToken();
  removePosition();
};
